import {TrackErrorPageViewInterface} from '../interfaces/track-error-page-view.interface';
import {GlobalAnalyticsVariablesInterface} from '../interfaces';
import {retrieveMergeResponseGlobalVarsCase} from './retrieve-merge-response-global-vars.case';
import {analyticsConstants} from '../../constants';

export const trackErrorPageViewPayloadCase = (
  pageName: string,
  globalVariables?: GlobalAnalyticsVariablesInterface,
): TrackErrorPageViewInterface => {
  const data = {
    pageName,
    siteSection: analyticsConstants.APP_NAME,
    siteType: analyticsConstants.SITE_TYPE
  };
  return retrieveMergeResponseGlobalVarsCase(true, data, globalVariables);
};
